import { useState, useContext } from 'react';
import { AuthContext } from '../../contexts/auth';
import {FiInbox} from "react-icons/fi";
import {Link,} from 'react-router-dom';
import './login.css';
import Logo from '../../components/Logo';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { login } = useContext(AuthContext);

  function handleSubmit(e){
    e.preventDefault();

    const data = {
      email: email,
      password: password
    };

    login(data);
  }

  return (
    <div className="content-page">
      <div className="content-view">
        <div className="logo-view">
          <Logo />
        </div>
      </div>

      <div className="content-login">
        <div className="login">
          <form className="formLogin" onSubmit={handleSubmit}>
            <h1><FiInbox color="#FFF" size={50} /><label className="label-title">WMS Gruppe</label></h1>
            <input type="text" placeholder="Login ou E-mail" value={email} onChange={ (e) => setEmail(e.target.value) }/>
            <input type="password" placeholder="*******" value={password} onChange={(e) => setPassword(e.target.value) } />
            <button className="loginButton" type="submit">Acessar</button>
            <div className="content-recuperacao">
              <Link to={'/password/recovery'}>Recuperar senha</Link>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
}

export default SignIn;
